export const DetectVersion = {
  methods: {
    VERSION: function() {
      return process.env.VERSION;
    }
  }
};
